module.exports = __webpack_public_path__ + "img/logoCuCi.dcc4f1ba.png";